import React from 'react';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

interface SongNotesFieldProps {
  notater: string;
  onNotaterChange: (value: string) => void;
}

export const SongNotesField: React.FC<SongNotesFieldProps> = ({
  notater,
  onNotaterChange,
}) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="notes">Notater</Label>
      <Textarea
        id="notes"
        placeholder="Ekstra informasjon om sangen..."
        value={notater}
        onChange={(e) => onNotaterChange(e.target.value)}
        className="min-h-[100px] resize-y bg-slate-50/50 focus:bg-white"
      />
    </div>
  );
};

